import { defineStore } from 'pinia';

export const useSuccessStore = defineStore('success', {
  state: () => ({
    messages: null as string[]|null,
    forceShow: false,
  }),
  actions: {
    setMessage(message: string|string[]) {
      if (this.messages === null) {
        this.messages = !Array.isArray(message) ? [message] : message;
        return;
      }
      if (Array.isArray(this.messages)) {
        if (Array.isArray(message)) this.messages.concat(message);
        else this.messages.push(message);
        return;
      }
    },
    closeMessage() {
      this.messages = null;
      this.forceShow = false;
    },
    saveSuccessful() {
      this.setMessage('Saved Successfully');
    }
  }
});
